import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const TermsConditions = () => {
  return (
    <>
      <Header />

      <div
        className="container"
        style={{
          marginTop: "150px",
          marginBottom: "60px",
          maxWidth: "1000px",
        }}
      >
        {/* Hero Section */}
        <div
          className="text-center text-white p-5 rounded"
          style={{
            background:
              "linear-gradient(135deg, #6B2A00 0%, #E3952A 100%)",
          }}
        >
          <h1 className="fw-bold mb-3">
            Terms & Conditions
          </h1>

          <p className="mb-0">
            Please read these terms carefully before
            using Ez Puja Path services.
          </p>
        </div>

        {/* Content */}
        <div
          className="bg-white shadow-sm rounded p-4 p-md-5 mt-4"
          style={{
            lineHeight: "1.9",
            color: "#444",
          }}
        >
          <p>
            <strong>Last Updated:</strong> June 2026
          </p>

          <p>
            Welcome to <strong>Ez Puja Path</strong>.
            By accessing or using our website,
            mobile platform, or services, you agree
            to be bound by these Terms &
            Conditions.
          </p>

          <h3 className="mt-4">
            1. Acceptance of Terms
          </h3>

          <p>
            By using Ez Puja Path, you acknowledge
            that you have read, understood, and
            agreed to comply with these Terms &
            Conditions and all applicable laws and
            regulations.
          </p>

          <h3 className="mt-4">
            2. Services Offered
          </h3>

          <p>
            Ez Puja Path provides online and
            offline religious services including but
            not limited to:
          </p>

          <ul>
            <li>Puja Booking Services</li>
            <li>Pandit Booking Services</li>
            <li>Online Puja Services</li>
            <li>Astrology Consultations</li>
            <li>Religious Event Assistance</li>
            <li>Spiritual Guidance Services</li>
          </ul>

          <h3 className="mt-4">
            3. User Responsibilities
          </h3>

          <p>
            Users agree to:
          </p>

          <ul>
            <li>
              Provide accurate and complete
              information.
            </li>
            <li>
              Maintain confidentiality of login
              credentials.
            </li>
            <li>
              Use the platform only for lawful
              purposes.
            </li>
            <li>
              Respect service providers and
              platform policies.
            </li>
          </ul>

          <h3 className="mt-4">
            4. Booking and Payments
          </h3>

          <ul>
            <li>
              All bookings are subject to
              availability.
            </li>
            <li>
              Users must provide correct booking
              details.
            </li>
            <li>
              Payments must be completed using
              approved payment methods.
            </li>
            <li>
              Booking confirmations are issued
              after successful payment or
              verification.
            </li>
          </ul>

          <h3 className="mt-4">
            5. Pricing
          </h3>

          <p>
            Service prices displayed on the website
            are subject to change without prior
            notice. Taxes and additional charges, if
            applicable, may be added at checkout.
          </p>

          <h3 className="mt-4">
            6. Cancellation and Refunds
          </h3>

          <p>
            Cancellation and refund requests shall
            be governed by our Refund &
            Cancellation Policy available on the
            website.
          </p>

          <h3 className="mt-4">
            7. Intellectual Property
          </h3>

          <p>
            All content, logos, images, graphics,
            trademarks, text, and software
            available on Ez Puja Path are owned by
            or licensed to us and are protected by
            applicable intellectual property laws.
          </p>

          <h3 className="mt-4">
            8. Prohibited Activities
          </h3>

          <p>
            Users shall not:
          </p>

          <ul>
            <li>
              Attempt unauthorized access to the
              platform.
            </li>
            <li>
              Upload harmful or malicious content.
            </li>
            <li>
              Use the website for fraudulent
              purposes.
            </li>
            <li>
              Violate applicable laws or
              regulations.
            </li>
          </ul>

          <h3 className="mt-4">
            9. Limitation of Liability
          </h3>

          <p>
            Ez Puja Path shall not be liable for any
            indirect, incidental, special, or
            consequential damages arising from the
            use of our services, website, or third-
            party integrations.
          </p>

          <h3 className="mt-4">
            10. Third-Party Services
          </h3>

          <p>
            We may integrate third-party services
            such as payment gateways, analytics,
            communication tools, and service
            providers. We are not responsible for
            their independent policies or actions.
          </p>

          <h3 className="mt-4">
            11. Modification of Services
          </h3>

          <p>
            We reserve the right to modify,
            suspend, or discontinue any service or
            feature without prior notice.
          </p>

          <h3 className="mt-4">
            12. Termination
          </h3>

          <p>
            We reserve the right to suspend or
            terminate user access in case of policy
            violations, fraudulent activity, or misuse
            of the platform.
          </p>

          <h3 className="mt-4">
            13. Governing Law
          </h3>

          <p>
            These Terms & Conditions shall be
            governed by and interpreted in
            accordance with the laws of India.
          </p>

          <h3 className="mt-4">
            14. Contact Information
          </h3>

          <p>
            For questions regarding these Terms &
            Conditions, please contact:
          </p>

          <div
            className="p-4 rounded"
            style={{
              background: "#f8f9fa",
              borderLeft: "4px solid #E3952A",
            }}
          >
            <p className="mb-2">
              <strong>Ez Puja Path</strong>
            </p>

            <p className="mb-2">
              Email: info@ezpujapath.com
            </p>

            <p className="mb-2">
              Website: https://ezpujapaath.com
            </p>

            <p className="mb-0">
              Phone: +91 XXXXX XXXXX
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default TermsConditions;
